module.exports = __webpack_public_path__ + "img/CosmicRedBrownie.0f88153c.png";